const presets = {
  textStyles: {
    foo: {
      color: "red.500",
    },
  },

  layerStyles: {
    foreground: {
      rounded: 5,
      overflow: "hidden",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
    },

    outlined: {
      rounded: 5,
      borderStyle: "solid",
      borderWidth: "3px",
      borderColor: "background.800",
    },

    cta: {},
  },
}

export default presets
